(() => {
  if (window.__trevanoProductSelectorReady) return;
  window.__trevanoProductSelectorReady = true;

  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
  const updateCampaignLink = (link) => {
    const destination = new URL(link.href, window.location.origin);
    const current = new URL(window.location.href);
    campaignKeys.forEach((key) => {
      if (current.searchParams.has(key)) destination.searchParams.set(key, current.searchParams.get(key));
    });
    link.href = destination.toString();
  };
  const updateLinks = () => document.querySelectorAll('[data-tv-selector-link]').forEach(updateCampaignLink);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  else updateLinks();

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-tv-selector-link]');
    if (!link) return;
    updateCampaignLink(link);

    if (window.Shopify?.analytics?.publish) {
      Shopify.analytics.publish('trevano_product_selector_used', {
        from_product_id: document.querySelector('product-info')?.dataset.productId || '',
        to_product_id: link.dataset.productId || '',
        size: link.dataset.size || '',
        design: link.dataset.design || '',
        page_context: 'product',
      });
    }
  });
})();
